const {KitModule, registerModule} = window;

import Swiper from 'swiper';
import {A11y, Autoplay, EffectFade, Pagination} from 'swiper/modules';

/**
 * Featured logoGrid tile powered by Swiper: cross-fades between up to four
 * featured logos and can be swiped on touch. Auto-advances (paused on hover and
 * disabled when the OS prefers reduced motion). Pagination bullets render into
 * the tile's own .logoSpotlight__dots element, styled as the corner dots.
 */
class LogoSpotlight extends KitModule {
    constructor($element) {
        super($element);

        this.$swiper = this.$element.querySelector('.swiper');
        this.$dots = this.$element.querySelector('.logoSpotlight__dots');

        // A single slide needs no carousel — leave the lone slide in place.
        const slideCount = this.$element.querySelectorAll('.swiper-slide').length;
        if (!this.$swiper || slideCount < 2) return;

        const autoplayMs = parseInt(this.$element.dataset.autoplay || '0', 10);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


        this.swiper = new Swiper(this.$swiper, {
            modules: [A11y, Autoplay, EffectFade, Pagination],
            slidesPerView: 1,
            loop: true,
            grabCursor: true,
            // Cross-fade preserves the tile's original look; swiping still works.
            effect: 'fade',
            fadeEffect: {crossFade: true},
            autoplay: (autoplayMs > 0 && !reducedMotion) ?
                {delay: autoplayMs, disableOnInteraction: false, pauseOnMouseEnter: true} :
                false,
            pagination: {
                el: this.$dots,
                clickable: true,
                bulletClass: 'logoSpotlight__dot',
                bulletActiveClass: 'is-active',
                bulletElement: 'button',
                renderBullet(index, className) {
                    return `<button type="button" class="${className}" aria-label="Show featured customer ${index + 1}"></button>`;
                },
            },
        });
    }
}

registerModule('LogoSpotlight', LogoSpotlight);
